module.exports = __webpack_public_path__ + "static/media/iconsGradient.729086bc.png";